import { render, staticRenderFns } from "./ForumDetail.vue?vue&type=template&id=5bde90ac&scoped=true"
import script from "./ForumDetail.vue?vue&type=script&lang=js"
export * from "./ForumDetail.vue?vue&type=script&lang=js"
import style0 from "./ForumDetail.vue?vue&type=style&index=0&id=5bde90ac&prod&scoped=true&lang=css"
import style1 from "./ForumDetail.vue?vue&type=style&index=1&id=5bde90ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bde90ac",
  null
  
)

export default component.exports